import React, { useRef, useState } from "react";
import { TopButs } from "./TopButs";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { TabBar } from "./TabBar";


export const SalesDetails = () => {
    const { getSelectedNavState } = useNavModel(() => []);
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const formRef = useRef<IYhFormRef>();
    return (
        <>
            {detailsInfo && <>
                <div id="aaaaa">
                    <TopButs formRef={formRef} {...detailsInfo} />
                    <TabBar formRef={formRef} {...detailsInfo} />
                </div>
            </>
            }
        </>
    )
}